import clsx from "clsx";
import { useState } from "react";
import SvgChevronDown from "../../svg/icons/ChevronDown";
import style from "./AccordionList.module.sass";
import { Button } from "./Button";
import { Collapsible } from "./Collapsible";

export const AccordionList = ({
	defaultOpen,
	children,
	translate,
}: {
	defaultOpen?: boolean;
	children: React.ReactNode;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	translate: any;
}) => {
	const [isOpen, setIsOpen] = useState(defaultOpen || false);
	const toggleOpen = () => setIsOpen((prev) => !prev);

	return (
		<div className={style.accordionList}>
			{!defaultOpen && (
				<div className={style.accordionButtonWrapper}>
					<Button
						type={{ variant: "naked" }}
						label={
							isOpen
								? translate("productPage.button.showLess")
								: translate("productPage.button.showMore")
						}
						iconAfter={
							<span className={clsx(style.icon, isOpen && style.iconRotate)}>
								<SvgChevronDown />
							</span>
						}
						icon={{ fillPrimary: true }}
						onClick={toggleOpen}
					/>
				</div>
			)}
			<Collapsible open={isOpen} slowerAnimation>
				<div className={style.accordionContent}>{children}</div>
			</Collapsible>
		</div>
	);
};
